<template>
    <div>
        <SafeTask v-if="json.type==='SAFETY_POSITION'" :unitId="json.unitId" :positionId="json.safetyPositionId"/>
        <Device v-else-if="json.type==='DEVICE_SN'" :sn="json.sn"/>
        <div v-else>
            {{$route.params}}
        </div>
    </div>
</template>

<script>
    import SafeTask from "../safety/PameraSafeTask"
    import Device from "../device/PameraDevice"

    export default {

        components: {
            SafeTask, Device
        },
        data() {

            return {
                qrRet: this.$route.params,
                json: {}
            }
        },

        created() {
            const {str} = this.$route.params
            !this.isSn(str) &&
            !this.isJson(str) &&
            this.handleError()
        },
        methods: {
            isSn(str) {
                if (/^\w+$/.test(str)) {
                    this.json = {type: 'DEVICE_SN', sn: str}
                    return true
                } else {
                    return false
                }
            },
            isJson(str) {
                let json
                try {
                    json = JSON.parse(str)
                } catch (e) {
                    // 不是json
                    return false
                }
                this.json = json
                return json
            },
            handleError() {
                this.$toast.fail('该二维码格式不规范')
            }
        }
    }
</script>

<style scoped>

</style>